import { Plus, Trash2 } from 'lucide-react';
import { parseInitiativesCards, serializeInitiativesCards } from '../../utils/siteLabelsEditors';

/**
 * @param {{ value: string, onChange: (json: string) => void }} props
 */
export default function InitiativesCardsEditor({ value, onChange }) {
  const cards = parseInitiativesCards(value);

  const update = (next) => {
    onChange(serializeInitiativesCards(next));
  };

  return (
    <div className="site-labels-visual">
      <p className="form-hint site-labels-visual-intro">
        Cards on the Initiatives page. Add a title and short description for each.
      </p>
      <div className="site-labels-visual-rows">
        {cards.map((card, index) => (
          <div className="site-labels-visual-group card" key={`ic-${index}`}>
            <div className="site-labels-visual-group-head">
              <label className="site-labels-visual-field site-labels-visual-field-grow">
                <span className="site-labels-visual-label">Card title</span>
                <input
                  type="text"
                  className="input"
                  value={card.title}
                  placeholder="e.g. Environmental Conservation"
                  onChange={(e) => {
                    const next = [...cards];
                    next[index] = { ...next[index], title: e.target.value };
                    update(next);
                  }}
                />
              </label>
              <button
                type="button"
                className="btn btn-ghost site-labels-visual-remove"
                aria-label="Remove card"
                onClick={() => update(cards.filter((_, i) => i !== index))}
                disabled={cards.length <= 1}
              >
                <Trash2 size={18} />
              </button>
            </div>
            <label className="site-labels-visual-field">
              <span className="site-labels-visual-label">Description</span>
              <textarea
                className="input site-labels-textarea"
                rows={4}
                value={card.description}
                placeholder="Short paragraph…"
                onChange={(e) => {
                  const next = [...cards];
                  next[index] = { ...next[index], description: e.target.value };
                  update(next);
                }}
              />
            </label>
          </div>
        ))}
      </div>
      <button
        type="button"
        className="btn btn-secondary site-labels-visual-add"
        onClick={() => update([...cards, { title: '', description: '' }])}
      >
        <Plus size={16} /> Add card
      </button>
    </div>
  );
}
